import { RouteConfig } from 'vue-router'
import Page from '@/Core/views/Page/Page.vue'
import List from './pages/List/List.vue'
import { Roles } from '../UsersManager/models'

export enum BillingErrorsPages {
  List = 'billing-errors-list',
}

const routes: Array<RouteConfig> = [
  {
    path: '/billing-errors',
    component: Page,
    children: [
      {
        path: '',
        name: BillingErrorsPages.List,
        meta: { menuActive: 'billingErrors', denyRolesAcess: [Roles.Marketer.code] },
        component: List
      },
    ]
  }
]

export default routes